/**
 * offlineCache.js — Offline Dashboard Snapshot
 *
 * Saves/restores a lightweight snapshot of dashboard data to localStorage
 * so the app can show stale-but-useful data when offline.
 */

const CACHE_KEY = 'spendable_offline_snapshot';

/**
 * Save a dashboard snapshot to localStorage.
 *
 * @param {Object} data - { checkingBalance, spendable, dailyAllowance, unpaidBillsCount, unpaidBillsTotal }
 */
export function saveOfflineSnapshot(data) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({
      ...data,
      savedAt: new Date().toISOString(),
    }));
  } catch (err) {
    console.warn('[offlineCache] Failed to save:', err);
  }
}

/**
 * Retrieve the cached dashboard snapshot.
 *
 * @returns {Object|null} Cached data or null
 */
export function getOfflineSnapshot() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    console.warn('[offlineCache] Failed to read:', err);
    return null;
  }
}
